import { assertNever } from "../../../util/assertNever";
import { GenericTableSchemaFormat } from "../enum.genericTableSchemaFormat";
import { FilterValueType, GenericTableFilterType } from "../type.genericTableQuery";
import { FieldDefinition } from "../type.genericTableSchema";
import { ArrayFilterMapper } from "./arrayFilterMapper";
import { BooleanFilterMapper } from "./booleanFilterMapper";
import { DateFilterMapper } from "./dateFilterMapper";
import type { FilterMapper } from "./interface.filterMapper";
import { NumberFilterMapper } from "./numberFilterMapper";
import { StringFilterMapper } from "./stringFilterMapper";

export function mapFieldDefinitionToFilterType(fieldDefinition: FieldDefinition): FilterValueType["type"] {
  const format = fieldDefinition.format;
  switch (format) {
    case GenericTableSchemaFormat.ARRAY:
      return GenericTableFilterType.ARRAY;
    case GenericTableSchemaFormat.BOOLEAN:
      return GenericTableFilterType.BOOLEAN;
    case GenericTableSchemaFormat.INTEGER:
    case GenericTableSchemaFormat.FLOAT:
    case GenericTableSchemaFormat.DECIMAL:
      return GenericTableFilterType.NUMBER;
    case GenericTableSchemaFormat.DATE:
    case GenericTableSchemaFormat.DATE_TIME:
      return GenericTableFilterType.DATE;
    case GenericTableSchemaFormat.STRING:
    case GenericTableSchemaFormat.LANGUAGE_RECORD:
      return GenericTableFilterType.STRING;
    case GenericTableSchemaFormat.JSON:
      throw new Error(`No filter available for field with format: ${format}`);
    default:
      assertNever(format);
  }
}

export function filterMapperFactory(type: FilterValueType["type"]): FilterMapper {
  switch (type) {
    case GenericTableFilterType.ARRAY:
      return new ArrayFilterMapper();
    case GenericTableFilterType.BOOLEAN:
      return new BooleanFilterMapper();
    case GenericTableFilterType.NUMBER:
      return new NumberFilterMapper();
    case GenericTableFilterType.DATE:
      return new DateFilterMapper();
    case GenericTableFilterType.STRING:
      return new StringFilterMapper();
    default:
      assertNever(type);
  }
}
